import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { app_permissions } from '../security/app-permissions';
import { CreateLogisticsProjectComponent } from './create-logistics-project/create-logistics-project.component';

export const logisticsProjectRoutes: Routes = [
    {
        path: 'cf-executions',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['PROJECTS'], enterpriseFeatureLabel: 'C&F Execution' },
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./cf-executions/cf-execution-list.component')
                        .then(m => m.CfExecutionListComponent),
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.logisticsProjects.projects.view }
            },
            {
                path: 'requests',
                loadComponent: () =>
                    import('./cf-executions/cf-request-workbench.component')
                        .then(m => m.CfRequestWorkbenchComponent),
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.logisticsProjects.projects.view }
            }
        ]
    },
    {
        path: 'logistics-projects',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['PROJECTS'], enterpriseFeatureLabel: 'Logistics Projects' },
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./logistics-project-list/logistics-project-list.component')
                        .then(m => m.LogisticsProjectListComponent),
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.logisticsProjects.projects.view,
                    groupPermission: app_permissions.logisticsProjects.financials.groupView }
            },
            {
                path: 'create',
                component: CreateLogisticsProjectComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.logisticsProjects.projects.create }
            },
            {
                path: ':projectId/edit',
                component: CreateLogisticsProjectComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.logisticsProjects.projects.edit }
            },
            {
                path: ':projectId',
                loadComponent: () =>
                    import('./logistics-project-detail/logistics-project-detail.component')
                        .then(m => m.LogisticsProjectDetailComponent),
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.logisticsProjects.projects.view,
                    groupPermission: app_permissions.logisticsProjects.financials.groupView }
            }
        ]
    }
];
